import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, extractError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (!token) {
      toast.error("Enlace inválido. Solicite uno nuevo.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Contraseña actualizada");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#F9F8F6]">
      <div className="w-full max-w-sm bg-white border border-[#E2DFD8] rounded-md p-8">
        <div className="label-caps mb-2">Nueva contraseña</div>
        <h1 className="font-display text-2xl font-medium mb-2">Restablecer acceso</h1>
        <p className="text-sm text-[#59645E] mb-6">Elija una contraseña de al menos 6 caracteres.</p>
        {!token ? (
          <p className="text-sm text-red-700 mb-4">
            Falta el token del enlace. Use el correo completo o solicite uno nuevo.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="password"
              required
              minLength={6}
              placeholder="Nueva contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-[#E2DFD8] rounded-sm text-sm"
            />
            <input
              type="password"
              required
              minLength={6}
              placeholder="Confirmar contraseña"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="w-full px-3 py-2 border border-[#E2DFD8] rounded-sm text-sm"
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1B4332] text-white text-sm py-2.5 rounded-sm disabled:opacity-60"
            >
              {loading ? "Guardando…" : "Guardar contraseña"}
            </button>
          </form>
        )}
        <p className="mt-6 text-center text-sm space-y-2">
          <Link to="/olvide-contraseña" className="block text-[#1B4332] underline">
            Solicitar nuevo enlace
          </Link>
          <Link to="/login" className="block text-[#59645E] underline">
            Iniciar sesión
          </Link>
        </p>
      </div>
    </div>
  );
}
